import { ResourceNotFoundView } from '@backoffice-frontend/patterns'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export const PageNotFoundView = () => {
  const { t } = useTranslation()
  return (
    <ResourceNotFoundView>
      <Link to="/">
        {t('authenticatedAppView_pageNotFound_returnToHomepage')}
      </Link>
    </ResourceNotFoundView>
  )
}
